import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { anything, instance, mock, verify, when } from 'ts-mockito';
import { Business } from '../../models/business';
import { Customer } from '../../models/customer';
import { Features } from '../../models/features';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { ValidationHelpers } from '../../services/validation-helpers';
import { MyWallet } from './my-wallet';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('my-wallet', () => {
			let component: MyWallet;
			const mockRouter: Router = mock(Router);
			const mockState: State = mock(State);
			const mockCustomer: Customer = mock(Customer);
			const mockBusiness: Business = mock(Business);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockI18N: I18N = mock(I18N);
			const mockValidationHelpers: ValidationHelpers = mock(ValidationHelpers);

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			// Initialize Component
			beforeEach(() => {
				const features = new Features({});
				when(mockState.features).thenReturn(features);
				when(mockState.business).thenReturn(instance(mockBusiness));
				when(mockBusiness.portalSettings).thenReturn({
					businessSettings: {
						isInvoiceEnabled: true
					}
				});
				when(mockState.customer).thenReturn(instance(mockCustomer));
				component = new MyWallet(
					instance(mockRouter),
					instance(mockPayrazrService),
					instance(mockState),
					instance(mockI18N)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
			});

			describe('addNewPaymentMethod()', () => {
				const routes: any[] = [
					{
						name: 'addPaymentMethod',
						route: 'test1'
					}
				];
				it('should navigate to add page with info', () => {
					when(mockRouter.routes).thenReturn(routes);
					when(mockRouter.navigateToRoute(anything())).thenReturn();
					component.addNewPaymentMethod('testMethod');
					verify(mockRouter.navigateToRoute(anything())).called();
					expect(routes[0].paymentMethodType).toEqual('testMethod');
					expect(routes[0].isCreateMethod).toEqual(true);
				});
			});

			describe('setCustomerPrimaryPaymentMethod()', () => {
				it('should handle success', async () => {
					when(mockPayrazrService.setCustomerPrimaryPaymentMethod(anything(), anything(), anything())).thenResolve({
						isSuccessful: true
					});
					const spyGetCustomerPaymentMethods = spyOn(component, 'getCustomerPaymentMethods').and.stub();

					await component.setCustomerPrimaryPaymentMethod('12', 'Card');
					expect(spyGetCustomerPaymentMethods).toHaveBeenCalled();
				});
			});

			describe('editAccount()', () => {
				const routes: any[] = [
					{
						name: 'editPaymentMethod',
						route: 'test1'
					}
				];
				it('should navigate with data', () => {
					when(mockRouter.routes).thenReturn(routes);
					when(mockRouter.navigateToRoute(anything())).thenReturn();
					component.editAccount('Card', '12345');
					expect(routes[0].paymentMethodType).toEqual('Card');
					expect(routes[0].isCreateMethod).toBeFalsy();
					expect(routes[0].account).toEqual('12345');
				});
			});

			describe('removeAccount()', () => {
				it('should call remove service', async () => {
					const spyConfirmPaymentDelete = spyOn(component, 'confirmPaymentDelete').and.returnValue(true);
					const spyGetCustomerPaymentMethods = spyOn(component, 'getCustomerPaymentMethods').and.stub();
					when(mockPayrazrService.removePaymentMethod(anything(), anything(), anything())).thenResolve({
						isSuccessful: true
					});
					await component.removeAccount('Card', '123');
					verify(mockPayrazrService.removePaymentMethod(anything(), anything(), anything())).called();
					expect(spyGetCustomerPaymentMethods).toHaveBeenCalled();
				});
			});

			describe('getCustomerPaymentMethods()', () => {
				const methods = [
					{
						test: 'test'
					}
				];
				when(mockPayrazrService.getCustomerPaymentMethodsByCustomerId(anything())).thenResolve({
					isSuccessful: true,
					entity: methods
				});
				it('should call the get service', async () => {
					await component.getCustomerPaymentMethods();
					expect(component.customer.paymentMethods).toEqual(methods);
				});
			});
		});
	});
});
